import { createApp } from "vue"
import rutsolve from "@/rutsolve.vue"
import router from "@/router"
import "@/public/base.css"

createApp(rutsolve).
    use(router).
    mount("#rutsolve")
